import { useRef } from "react";
import { useTitle } from "react-use";

import { CommandMenu, CommandMenuProvider } from "@/components/CommandMenu";
import { SubHeader } from "@/components/SubHeader";
import { Breadcrumb, Breadcrumbs } from "@/components/ui/breadcrumbs";
import { AccessionForm } from "../components/form-new/AccessionForm";
import { AdditionalSection } from "../components/form-new/AdditionalSection";
import { DonorSection } from "../components/form-new/DonorSection";
import { FooterSection } from "../components/form-new/FooterSection";
import { OrgSection } from "../components/form-new/OrgSection";
import { SamplesSection } from "../components/form-new/SampleSection";
import { TestsSection } from "../components/form-new/TestSection";

export function EntryPage() {
  useTitle("Create accession");
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <SubHeader>
        <SubHeader.Left>
          <Breadcrumbs>
            <Breadcrumb>Create accession</Breadcrumb>
          </Breadcrumbs>
        </SubHeader.Left>
      </SubHeader>
      <div
        className="flex flex-col items-center flex-1 overflow-y-auto pb-12 md:pb-0 bg-muted/20"
        ref={containerRef}
      >
        <div className="max-w-3xl w-full p-6 mx-auto relative">
          <AccessionForm containerRef={containerRef}>
            <DonorSection />
            <OrgSection />
            <TestsSection />
            <SamplesSection />
            <AdditionalSection />
            <FooterSection />
          </AccessionForm>
        </div>
      </div>
      <CommandMenuProvider>
        <CommandMenu />
      </CommandMenuProvider>
    </>
  );
}
